






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { chunk } from 'lodash';
import { Slider, Carousel } from '../../../../components';
import Card from '../card';
import { IMentoringCardWrapper, CarouselData, CarouselItems } from './types';

@Component({
  components: {
    Slider,
    Card,
  },
})
export default class MentoringCardWrapper extends Vue
  implements IMentoringCardWrapper {
  @Prop({ type: Array, default: () => [] })
  readonly items!: CarouselItems;

  @Prop({ type: Number, default: 5 })
  readonly step!: number;

  get isCaruselData(): boolean {
    const { items, step } = this;
    return items.length > step;
  }

  get caruselData(): CarouselData {
    const { items, isCaruselData, step } = this;
    return isCaruselData && chunk(items, step);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/components/cardwrapper/MentoringCardWrapper.vue